import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckBranch } from '@api/hitoryCheck';

import { THCExportBranchDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { ESnackbarTypes } from '@enums/common';

import { HC_BRANCH_DETAILS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportHcBranch = () => {
	const dispatch = useAppDispatch();

	const { mutate } = useMutation<THCExportBranchDTO>({
		mutationKey: [HC_BRANCH_DETAILS_EXPORT],
		mutationFn: exportHistoryCheckBranch,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportBranch: mutate };
};
